import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=18bd01a2&scoped=true&"
import script from "./textarea.vue?vue&type=script&lang=js&"
export * from "./textarea.vue?vue&type=script&lang=js&"
import style0 from "./textarea.vue?vue&type=style&index=0&id=18bd01a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd01a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18bd01a2')) {
      api.createRecord('18bd01a2', component.options)
    } else {
      api.reload('18bd01a2', component.options)
    }
    module.hot.accept("./textarea.vue?vue&type=template&id=18bd01a2&scoped=true&", function () {
      api.rerender('18bd01a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/textarea/textarea.vue"
export default component.exports